/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGlobe = createReactComponent("outline", "globe", "IconGlobe", [["path", { "d": "M7 9a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M5.75 15a8.015 8.015 0 1 0 9.25 -13", "key": "svg-1" }], ["path", { "d": "M11 17v4", "key": "svg-2" }], ["path", { "d": "M7 21h8", "key": "svg-3" }]]);

export { IconGlobe as default };
//# sourceMappingURL=IconGlobe.mjs.map
